import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect } from "react";
import {
  getTypesError,
  getTypesStatus,
  getTypesSuccess,
  getTypesLoading,
  modifyType,
} from "../../../features/typeSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import OptionForm from "./optionForm";
import { OptionMode } from "../../../models/option.model";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const ModifyOption = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { restaurantId } = useRestaurant();
  const data = location.state.type;
  const status = useSelector(getTypesStatus);
  const error = useSelector(getTypesError);
  const loading = useSelector(getTypesLoading);
  const success = useSelector(getTypesSuccess);

  const normalizeMode = (m) => {
    if (m === undefined || m === null) return null;
    const mm = String(m).toUpperCase();
    if (mm.startsWith(OptionMode.ingredients)) return OptionMode.ingredients;
    if (mm.startsWith(OptionMode.products)) return OptionMode.products;
    return mm;
  };

  const initialMode = normalizeMode(data?.mode)
    ? normalizeMode(data?.mode)
    : Array.isArray(data?.ingredients) && data.ingredients.length
    ? OptionMode.ingredients
    : Array.isArray(data?.products) && data.products.length
    ? OptionMode.products
    : OptionMode.ingredients;

  const initialValues = {
    name: data.name,
    label: data.label,
    message: data.message,
    max: data.max,
    min: data.min,
    payment: data.payment,
    selection: data.selection,
    mode: initialMode,
    ingredients: Array.isArray(data.ingredients)
      ? data.ingredients
          .sort((a, b) => a.position - b.position)
          .map((i) => (i.ingredient?._id ? i.ingredient._id : i._id))
      : [],
    products: Array.isArray(data.products)
      ? data.products
          .sort((a, b) => a.position - b.position)
          .map((p) => (p.product?._id ? p.product._id : p._id))
      : [],
  };

  const handleFormSubmit = (values) => {
    const requestBody = {
      name: values.name,
      label: values.label,
      message: values.message,
      max: values.max,
      min: values.min,
      payment: values.payment,
      selection: values.selection,
      mode: normalizeMode(values.mode) || values.mode,
      // ingredients: (normalizeMode(values.mode) || values.mode) === OptionMode.ingredients ? values.ingredients : [],
      // products: (normalizeMode(values.mode) || values.mode) === OptionMode.products ? values.products : [],
    };
    if (values.mode === OptionMode.ingredients) {
      requestBody.ingredients = values.ingredients.map((id, index) => ({
        ingredient: id,
        position: index,
      }));
      requestBody.products = [];
    } else if (values.mode === OptionMode.products) {
      requestBody.products = values.products.map((id, index) => ({
        product: id,
        position: index,
      }));
      requestBody.ingredients = [];
    }
    dispatch(
      modifyType({
        body: requestBody,
        typeId: data._id,
        restaurantId,
      })
    );
  };

  useEffect(() => {
    if (status === "modifySuccess") {
      toast.success(success);
      navigate("/options");
    } else if (status === "modifyError") {
      toast.error(error);
    }
  }, [status, error, dispatch, navigate, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton />
      <Header title={t("headers.editOption")} subtitle={t("headers.editOptionSub")} />
      <OptionForm
        buttonText={t("common.edit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        loading={loading}
      />
    </Box>
  );
};

export default ModifyOption;
